import type { ApplePayButton } from '#types/components/checkout/applePayButton'
import type { RecursivePartial } from '#types/utils'

export default {
  brandClasses: {
    button: 'bg-white'
  },
  variant: 'secondary'
} satisfies RecursivePartial<ApplePayButton>
